import React, { PureComponent, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from '../App';
import { RootState } from '../store';
import { ISession } from '../models/pro-sites';
import { loadSession } from '../store/session/session-actions';
import { loadTranslations } from '../store/translations/translation-actions';
import Auth from './authorization/auth';
import { CookiesProvider } from 'react-cookie';
import MsalAuth from './authorization/msal-auth';
import {
    loadFavorites,
    loadRecentlyViewedProducts,
    loadWishlists,
} from '../store/e-store/wish-list-slice';
import { useAppDispatch, useAppSelector } from '../hooks/redux-hooks';

interface RootProps {
    translations: any | null;
    session: ISession | null;
    spaPath: string;
    loadTranslations: () => Promise<void>;
    loadSession: () => Promise<void>;
    loading?: boolean;
}

export const Root = (props: RootProps) => {
    useEffect(() => {
        if (!props.translations) {
            props.loadTranslations();
        }

        if (!props.session) {
            props.loadSession();
        }
    }, []);

    return (
        props.translations &&
        props.session && (
            <CookiesProvider>
                <IntlProvider
                    locale="en"
                    messages={props.translations}
                    textComponent={React.Fragment}
                >
                    <BrowserRouter basename={props.spaPath}>
                        <MsalAuth>
                            <Auth>
                                <App />
                            </Auth>
                        </MsalAuth>
                    </BrowserRouter>
                </IntlProvider>
            </CookiesProvider>
        )
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        translations: state.translations,
        session: state.session ? state.session.data! : null,
        spaPath: state.spaPath,
        loading: !state.translations && !state.session,
    };
};

const mapDispatchToProps = {
    loadTranslations,
    loadSession,
};

const rootContainer = connect(mapStateToProps, mapDispatchToProps)(Root);

export default rootContainer;
